import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";
import useAnalytics from "hooks/useAnalytics";

import { ContextCellComponentProps } from "./types";

const ContextDescriptionCell = ({ context }: ContextCellComponentProps) => {
  const trackAnalytics = useAnalytics();

  const handleShowFullDescription = () => {
    trackAnalytics("Show full description clicked");
  };

  if (!context.contextDescription) {
    return null;
  }

  return (
    <ListEntitiesItemDescriptionMultipleLines
      lines={1}
      hasChevronLink
      description={context.contextDescription}
      onShowFullDescription={handleShowFullDescription}
    />
  );
};

export default ContextDescriptionCell;
